// Formatea horas de nómina con 2 decimales ("1.25", "8.00", "0.50").
//
// Por qué 2 y no 1: el input de horas usa step={0.25} (cuartos de hora), así que UN
// decimal no puede representar el dato — 1.25 se mostraba "1.3" y 1.75 "1.8", y el
// mismo valor se veía distinto en la línea de detalle (sin formato) que en la fila de
// totales. La DB guarda NUMERIC(4,2), o sea el valor exacto: esto es SOLO presentación,
// nunca hubo pérdida de dato.
//
// Helper único a propósito: el bug existió porque la misma regla estaba escrita en 6+
// lugares con toFixed(1). Toda superficie de horas del frontend debe pasar por acá.
//
// NO usar para el export a Sage: esa columna va en HH:MM (ver decimalHoursToHHMM en
// csvExportService.js) porque Sage lo exige junto a Manual/Timed Option=1. El CSV de
// conciliación (`/api/nomina/export-csv`) sí va en decimal, con su propia línea backend.
//
// Acepta number, string (pg devuelve NUMERIC como string), null o undefined.
// Un valor no numérico cae a "0.00" en vez de "NaN".
export function formatHours(value) {
  return (Number(value) || 0).toFixed(2);
}
